// Get references to the new video and image elements
var videoJewelry = document.getElementById('video-jewelry');
var imgJewelry = document.getElementById('img-jewelry');

// Reuse the existing logic for the new video
if (videoJewelry) {
    videoJewelry.controls = false;
    var playPromiseJewelry = videoJewelry.play();

    if (playPromiseJewelry !== undefined) {
        playPromiseJewelry.then(function() {
            if (imgJewelry) {
                imgJewelry.style.display = "none";  // Hide the image
            }
            videoJewelry.style.display = "block";    // Show the video
            videoJewelry.style.pointerEvents = "none"; // Keep the video non-interactive
        }).catch(function(error) {
            videoJewelry.style.display = "none";      // Hide the video
            if (imgJewelry) {
                imgJewelry.style.display = "block";   // Show the image
            }
        });
    } else {
        videoJewelry.style.display = "none";          // Hide the video
        if (imgJewelry) {
            imgJewelry.style.display = "block";       // Show the image
        }
    }
}
